export default __webpack_public_path__ + "static/shield-check-light.png";